// Plantilla 5 de notaría, «panel lateral» (ref: https://trello.com/c/0Ma2vfxV)

const DIAS_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

/**
 * Horario de hoy (hora de Madrid) desde el horario estructurado: «8:00 a 14:00 · 16:00 a 19:00».
 * null si la notaría no tiene horario estructurado; '' si hoy no abre.
 */
export function horarioDeHoy(tramos: any, ahora = new Date()): string | null {
  const lista = (Array.isArray(tramos) ? tramos : []).filter((t: any) => t?.Dias?.length && t.Abre && t.Cierra)
  if (!lista.length) return null
  const dia = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'long' }).format(ahora) || DIAS_EN[ahora.getDay()]
  const hora = (h: string) => h.replace(/^0(\d)/, '$1')
  return lista
    .filter((t: any) => t.Dias.includes(dia))
    .sort((a: any, b: any) => a.Abre.localeCompare(b.Abre))
    .map((t: any) => `${hora(t.Abre)} – ${hora(t.Cierra)}`)
    .join(' · ')
}

/** Etiqueta sobre el título de una sección: el nombre de la sección, solo si el título del panel dice otra cosa. */
export function etiquetaSeccion(tituloPanel: string | undefined, defecto: string): string {
  const titulo = String(tituloPanel || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
  return titulo && titulo.toLowerCase() !== defecto.toLowerCase() ? defecto : ''
}
